import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const prospectDriverApi = createApi({
  reducerPath: 'prospectDriverApi',
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: '/api/prospectDriver' }),
  tagTypes: ['ProspectDriver'],
  endpoints: (builder) => ({
    getProspectDrivers: builder.query({
      query: (params) => '?' + new URLSearchParams(params),
      providesTags: ['ProspectDriver']
    }),
    importProspectDriver: builder.mutation({
      query: (body) => ({
        url: 'import',
        method: 'POST',
        body
      }),
    }),
    sendEmail: builder.mutation({
      query: (body) => ({
        url: 'sendEmail',
        method: 'PUT',
        body
      }),
    }),
  })
});

export const {
  useLazyGetProspectDriversQuery,
  useImportProspectDriverMutation,
  useSendEmailMutation
} = prospectDriverApi;